module.exports = __webpack_public_path__ + "img/LP.a87921ab.png";